module.exports = __webpack_public_path__ + "img/instagram.d633e468.svg";